import React, { useContext, useState } from 'react';

import { Search } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    InputAdornment,
    Slide,
    TextField
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import InviteStudents from './InviteStudents';
import InviteStudentsContainer from '../../../../InviteStudents/InviteStudentsContainer';
import { RosterContext } from '../../../RosterContext';

const StyledIconButton = styled(IconButton)`
    position: absolute;
    right: 8px;
    top: 8px;
`;

const Transition = React.forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement;
        },
        ref: React.Ref<unknown>
    ) => <Slide direction="up" ref={ref} {...props} />
);

export interface RosterToolbarProps {
    searchText: string;
    handleChangeSearch: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

const RosterToolbar: React.FC<RosterToolbarProps> = ({ searchText, handleChangeSearch }) => {
    const { classId, classUuid, userUuid, loadRoster } = useContext(RosterContext);

    const [inviteStudentsOpen, setInviteStudentOpen] = useState(false);

    const { t } = useTranslation('roster');

    const handleInviteSuccess = async () => {
        loadRoster();
        setInviteStudentOpen(false);
    };

    return (
        <Grid container>
            <Grid item flexGrow={1}>
                <TextField
                    value={searchText}
                    onChange={handleChangeSearch}
                    size="small"
                    variant="standard"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>
            <Grid>
                <Button variant="outlined" sx={{ mt: 2, mr: 2 }} onClick={() => setInviteStudentOpen(true)}>
                    {t('add-students-2')}
                </Button>
                <Dialog open={inviteStudentsOpen} fullScreen TransitionComponent={Transition}>
                    <DialogTitle sx={{ m: 0, p: 2 }}>
                        {t('add-students-2')}
                        <StyledIconButton aria-label="close" onClick={() => setInviteStudentOpen(false)}>
                            <CloseIcon />
                        </StyledIconButton>
                    </DialogTitle>
                    <DialogContent>
                        <InviteStudentsContainer.Provider
                            initialState={{ classId: classId as string, classUuid, userUuid: userUuid as string }}
                        >
                            <InviteStudents
                                onCancel={() => setInviteStudentOpen(false)}
                                onSuccess={() => handleInviteSuccess()}
                            />
                        </InviteStudentsContainer.Provider>
                    </DialogContent>
                </Dialog>
            </Grid>
        </Grid>
    );
};

export default RosterToolbar;
